import React from 'react';
import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ mt: 6, width: '100%' }}>
      <Divider />
      <Container maxWidth="lg">
        <Box sx={{ py: 3 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            sx={{
              alignItems: { xs: 'center', sm: 'center' },
              justifyContent: 'space-between',
              textAlign: { xs: 'center', sm: 'left' },
            }}
          >
            <Typography variant="body2" color="text.secondary">
              © {year} Lexory
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={{ xs: 0.5, sm: 2 }}
              sx={{ alignItems: { xs: 'center', sm: 'center' } }}
            >
              <Link component={RouterLink} to="/terms-of-service" underline="hover" color="text.secondary">
                Terms of Service
              </Link>
              <Link component={RouterLink} to="/privacy-policy" underline="hover" color="text.secondary">
                Privacy Policy
              </Link>
              <Link component={RouterLink} to="/support" underline="hover" color="text.secondary">
                Support
              </Link>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
